<template>
  <div
    class="wl-banner flex flex-col gap-0.5 rounded-2xl p-4 text-sm"
    :class="[
      { 'bg-warning-transparent text-warning': type === 'warning' },
      { 'bg-theme-transparent text-default': type === 'default' },
      { 'bg-error-transparent text-error': type === 'error' },
    ]"
  >
    <div class="flex items-center">
      <WLIcon
        v-if="iconName"
        ref="bannerIconRef"
        :name="iconName"
        :size="IconSize.SMALL"
        :has-hover="false"
        class="mr-2 flex-shrink-0"
        has-current-color
      />
      <p v-if="title" ref="bannerTitleRef" class="font-medium">
        {{ title }}
      </p>
    </div>
    <p v-if="subtitle" ref="bannerSubtitleRef">
      {{ subtitle }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { IconSize, WLIcon } from "../icon";
import { type BannerProps } from "./types";

const {
  iconName,
  title,
  subtitle,
  type = "warning",
} = defineProps<BannerProps>();
</script>
